import { IonInfiniteScroll } from '@ionic/angular';
import { FAQModel } from 'src/app/models/user.model';
import { UserService } from './../../services/user.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PaginatedResponse } from './../../models/paginated-response.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
  selector: 'shc-faq',
  templateUrl: './faq.page.html',
  styleUrls: ['./faq.page.scss'],
})
export class FaqPage implements OnInit {
  page: number;
  loading: boolean;
  faqs: PaginatedResponse<FAQModel>;
  groupedFaqs: { category: string; items: FAQModel[] }[] = [];
  categoryOrder = ['coins_swopping', 'costs_subscription', 'shipping'];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

  constructor(
    private userService: UserService,
    private errorService: ErrorHandlerService
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.page = 1;
    this.getFaqs('');
  }

  getFaqs(event: any): void {
    this.loading = true;
    this.userService.getFaqs({ page: this.page, per_page: 30 }).subscribe(
      res => {
        this.loading = false;
        if (this.faqs && this.faqs.meta) {
          if (this.page === 1) {
            this.faqs = res;
          } else {
            this.faqs.meta = res.meta;
            this.faqs.data = [...this.faqs.data, ...res.data];
          }
        } else {
          this.faqs = res;
        }
        this.updateGroupedFaqs();
        if (event) {
          event.target.complete();
        }
        this.page++;
      },
      error => {
        this.loading = false;
        this.errorService.handle(error);
      }
    );
  }

  showDescription(id: number): void {
    const index = this.faqs.data.findIndex(x => x.id === id);
    this.faqs.data[index].show_description = !this.faqs.data[index].show_description;
  }

  updateGroupedFaqs(): void {
    const groups: { [key: string]: FAQModel[] } = {};
    (this.faqs?.data || []).forEach(faq => {
      const key = faq.category || 'other';
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(faq);
    });
    this.groupedFaqs = this.categoryOrder
      .filter(cat => groups[cat]?.length)
      .map(cat => ({ category: cat, items: groups[cat] }));
    Object.keys(groups)
      .filter(cat => !this.categoryOrder.includes(cat))
      .forEach(cat => this.groupedFaqs.push({ category: cat, items: groups[cat] }));
  }

  loadData(event): void {
    if (this.faqs.meta.current_page < this.faqs.meta.last_page) {
      this.getFaqs(event);
    } else {
      this.infiniteScroll.disabled = true;
    }
  }

}
